import React from "react"
import { graphql, Link } from "gatsby"
import "./image-link.module.scss"
import { ExternalLink } from "components/external-link/ExternalLink"
import { Image } from "components/image/Image"
import { useLayout } from "contexts/components/LayoutContext"
import { getRelativePathFromCodex } from "components/button/utils/getRelativePathFromCodex"

export const ImageLink = ({ image, external_link, page }) => {
  if (!image) return <></>

  const isInternalPage = page && !!page?.slug

  if (isInternalPage) {
    const { linkedPagesUrlPathCodex } = useLayout()

    const slug = getRelativePathFromCodex({
      codex: linkedPagesUrlPathCodex,
      path: page.slug,
      codexKeyStartsWithForwardSlash: false,
    })

    return (
      <Link to={slug}>
        <Image
          image={image}
          width={image.width}
          url={image.url}
          className="image-link"
        />
      </Link>
    )
  }

  if (external_link) {
    return (
      <ExternalLink href={external_link}>
        <Image
          image={image}
          width={image.width}
          url={image.url}
          className="image-link"
        />
      </ExternalLink>
    )
  }

  console.log("Please add a link to your image")

  return (
    <Image
      image={image}
      width={image.width}
      url={image.url}
      className="image-link"
    />
  )
}

export const query = graphql`
  fragment StrapiImageLinkFragment on STRAPI__COMPONENT_IMAGE_VARIATIONS_IMAGE {
    id
    image {
      ...StrapiImageFragment
    }
    page {
      slug
    }
    external_link
  }
`
